import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { promise } from 'protractor';
import { MeetingService } from './meeting.service';
import { SnackbarService } from '../snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class ProcteeService {

  company!: string;
  accessCode: string;
  requestId: string;
  username: string = 'Proctor_' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  name: string = 'Proctor';
  intervieweepassporturl: string;
  intervieweefullname: any;
  scheduleid: any
  req_headers;

  constructor(private http: HttpClient, private userservice: UserService, private toastr: SnackbarService, private meetingService: MeetingService) {
    this.req_headers = new HttpHeaders({
      "content-type": "application/json",
      "accept": "application/json",
      "Authorization": `Bearer ${this.userservice.getToken()}`,
      "skip_token_interceptor": "true"
    });
  }

  flagProctee(accesscode: string, examid: string, candidateno: string, reason: string, proctorname: string, attempt: number): Promise<any> {
    return this.http.post(environment.serviceurl + `/proctees/flag`,
      { accesscode: accesscode, examid: examid, candidateno: candidateno, reason: reason, proctorname: proctorname, examattempt: attempt },
      { headers: this.req_headers }).toPromise();
  }

  updateProcteeFlag(examid: string, candidateno: string, reviewcomments: string, unflag: boolean, unflaggedby: string, flagid: number) {
    return this.http.post(environment.serviceurl + `/proctees/updateflags`,
      { examid: examid, candidateno: candidateno, reviewcomments: reviewcomments, unflag: unflag, unflaggedby, flagid: flagid },
      { headers: this.req_headers }).toPromise();
  }

  getFlags(examid: string, candidateexamno: string = '', page = 1, itemsperpage = 50): any {
    return this.http.get(environment.serviceurl + `/proctees/getflags?examid=${encodeURI(examid)}&page=${page}&itemsPerPage=${itemsperpage}&candidateexamno=${candidateexamno}`, { headers: this.req_headers }).toPromise()
      .catch((error) => {
        this.toastr.error(`${error.status} ${error.statusText}`);
      });
  }

  getReqExams(): any {
    return this.http.get(`${environment.serviceurl}/requests/getrequestexamsbycompany?company=${this.userservice.getCompany()}`, { headers: this.req_headers }).toPromise()
      .catch((error) => {
        this.toastr.error(`${error.status} ${error.statusText}`);
      });
  }

  getPauseReasons(accesscode: any): any {
    return this.http.get(`${environment.cbtserviceurl}/exam/getpausereasons?accesscode=${accesscode}`,
       { headers: this.req_headers }).toPromise()
      .catch((error) => {
        this.toastr.error(`${error.status} ${error.statusText}`);
      });
  }

  pauseUnpauseProctee(accesscode, examid, candidateno, paused, reason, proctorfullname): Promise<any> {
    return this.http.post(environment.cbtserviceurl + `/exam/pauseunpausecandidate`,
      { accesscode: accesscode, company: this.userservice.getCompany(), examid: examid, candidateno: candidateno, paused: paused, reason: reason, proctorfullname: proctorfullname },
      { headers: this.req_headers }).toPromise()
      .catch((error) => {
        this.toastr.error(`${error.status} ${error.statusText}`);
      });
  }

  async getProctorInfo(_username: any = this.username, fullname: any = this.name) {
    const ret = await this.http.get<any>(`${environment.serviceurl}/requests/getproctorinfo?accesscode=${encodeURI(this.accessCode)}&username=${encodeURI(_username)}&name=${encodeURI(fullname)}`).toPromise();
    return ret;
  }
  // async getMeetingUrl(username, fullname){
  //   const ret = await this.http.get<any>(`${environment.serviceurl}/requests/getmeetingurl?accesscode=${encodeURI(this.accessCode)}&username=${encodeURI(this.username)}&name=${encodeURI(this.name)}`).toPromise();
  //   return ret;
  // }
  // async startProctor() {
  //   return await this.http.post(`${environment.serviceurl}/requests/startproctor`, { requestId: this.requestId, company: this.company }, { headers: this.req_headers }).toPromise();
  // }

  async createAndStartMeeting(username: string, name: string){
    return await this.http.post(`${environment.serviceurl}/requests/createandstartproctormeeting`, { accessCode: this.accessCode, name, username }, { headers: this.req_headers }).toPromise();
  }

  destroy() {
    this.accessCode = null;
    this.requestId = null;
    this.company = null;
  }

  // async getPassportUrl(): Promise<string> {
  //   const ret = await this.http.get<any>(`${environment.serviceurl}/requests/getpassporturl?accesscode=${this.accessCode}`).toPromise();
  //   return ret.passporturl;
  // }

  async getCandidatePassportUrl(username: string){
    return await (this.http.get<string>(`${environment.serviceurl}/proctees/getcandidatepassporturl?examNo=${encodeURIComponent(username)}`, { headers: this.req_headers })).toPromise();
  }

  async getCandidateInfoByAccessCode(accesscode: any): Promise<any> {
    return await (this.http.get(`${environment.serviceurl}/requests/getCandidateInfoByAccessCode?accesscode=${encodeURIComponent(accesscode)}`)).toPromise();
  }

  async submitinterviewgrades(data: any[], candidatescheduleid: any) {
    this.name ??= window.localStorage.getItem(environment.proctorusername)
    return await this.http.post(`${environment.serviceurl}/proctees/submitgrade`, { scores: data, scheduleid: candidatescheduleid, gradedby: this.name }, { headers: this.req_headers }).toPromise();
  }

  async getCandidates(examId: string): Promise<{examNo: string}[]>{
    const ret = await this.http.get<{examNo: string}[]>(`${environment.serviceurl}/proctees/getcandidates?examid=${encodeURIComponent(examId)}`, {headers: this.req_headers}).toPromise();
    return ret;
  }
  async getFlaggedCandidates(examId: string): Promise<{ examNo: string }[]> {
    const ret = await this.http.get<{ examNo: string }[]>(`${environment.serviceurl}/proctees/getcandidates?examid=${encodeURIComponent(examId)}&flaggedonly=true`, { headers: this.req_headers }).toPromise();
    return ret;
  }
  async start_endintervieweeexam(scheduleid, start = true): Promise<any> {
    debugger
    return this.http.post(environment.serviceurl + `/proctees/startendcandidateinterviewexam`,
      { accesscode: this.accessCode, company: this.userservice.getCompany(), scheduleid, start: start },
      { headers: this.req_headers }).toPromise()
      .catch((error) => {
        this.toastr.error(`${error.status} ${error.statusText}`);
      });
  }
}